import { LayoutComponents } from "../LayoutComponents";
import { Link } from "react-router-dom";

import { BsWhatsapp } from "react-icons/bs";

export const NotFound = () => {
  return (
    <LayoutComponents>
      <div className="home-container">
        <div className="home-content">
          <h1 className="home-title">
            <p style={{ color: "white", fontSize: "40%"}}>
              Oops... Essa página que você está tentando acessar não existe, verifique se o endereço na url está correto.
            </p>
          </h1>
          <br />
          <br />
          <p style={{ color: "#cccc" }} className="home-description">
            Se o error persistir entre em contato com a Equipe da TI(ESAT).
          </p>
          <br />
          <h3 className="btn text-white m-0 text-justify">
          <b>
            <a
              className="whatsapp-link"
              href="https://wa.me/5583993769417"
              target="_blank"
            >
              <BsWhatsapp
                style={{
                  display: "inline",
                  marginTop: "5px",
                  marginLeft: "2px",
                }}
              />
            </a>
          </b>
        </h3>
          <br />

          <div className="container-login-form-btn">
            <Link className="login-form-btn" to="/esat/sigecap/" style={{ textDecoration: "none" }}>Voltar </Link>
          </div>
        </div>
      </div>
    </LayoutComponents>
  );
};
